import {atom} from 'jotai';

export let romAtom = atom(null);